angular.module('app.controllers').controller('EditClientCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, notify, api, UserService, formValidator, variables) {
    $scope.statusOptions = [
        { value: 'client_active', label: $translate.instant('client_active') },
        { value: 'client_inactive', label: $translate.instant('client_inactive') },
        { value: 'client_deleted', label: $translate.instant('client_deleted') },
        { value: 'client_suspended', label: $translate.instant('client_suspended') },
    ];

    // dane
    const ClientModel = api('clients');

    $scope.client = {};
    if (0 < $stateParams.id) {
        const info = notify.info($translate.instant('loading'));
        ClientModel.get($stateParams.id).then((response) => {
            $scope.client = response;
            info.close();
            notify.success($translate.instant('loaded'));
            $scope.setupPhotoUploader();
            $rootScope.$broadcast('edit-panel-ready');
        });
    } else {
        $scope.client = {
            id: 0,
            author_id: UserService.getUser().id,
            address_country_id: variables.defaults.country_id,
            contact_country_id: variables.defaults.country_id,
            status: 'client_active',
        };
    }

    $scope.userOptions = [];
    api('users')
        .selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } })
        .then((response) => {
            $scope.userOptions = response.data;
        });

    $scope.countryOptions = [];
    api('dictionaries/countries')
        .selectize()
        .then((response) => {
            $scope.countryOptions = response.data;
        });

    // form validation
    const fv = formValidator('#ClientForm', $scope);

    $scope.saveClient = () => {
        if (!fv.isValid()) {
            return;
        }

        const redirectAfterSave = 0 == $scope.client.id;
        const info = notify.info($translate.instant('saving'));
        notify.global(1);

        ClientModel.save($scope.client.id, $scope.client).then((response) => {
            $scope.client = response;
            ClientModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
            $rootScope.$broadcast('edit-panel-ready');

            if (redirectAfterSave) {
                $state.go('restricted.clients_edit', { id: $scope.client.id });
            }
        });
    };

    $scope.setupPhotoUploader = () => {
        $scope.photoChanged = 0;

        const settings = {
            action: '/api/1/clients/$/photo'.replace('$', $scope.client.id),
            allow: '*.(jpg|jpeg|gif|png)',
            filelimit: 1,
            param: 'photo',
            single: true,
            loadstart() {
                notify.global(1);
            },
            progress(percent) {},
            allcomplete() {
                notify.global(0);
                $scope.photoChanged++;
                $scope.client.photo = true;
            },
        };
        UIkit.uploadSelect($('#user_edit_avatar_control'), settings);
    };
});
